// Tiny haptic helper — eyes-free confirmation for a scorer watching the
// pitch, not the phone. No-op on iOS Safari/desktop (no vibrate API).
export function buzz(pattern = 15) {
  try {
    if (navigator.vibrate) navigator.vibrate(pattern);
  } catch (_) {
    // vibration is best-effort only
  }
}
